var map = {
	"./rank.png": "./src/assets/imgs/school/monthRecord/rank.png",
	"./rank1.png": "./src/assets/imgs/school/monthRecord/rank1.png",
	"./rank2.png": "./src/assets/imgs/school/monthRecord/rank2.png",
	"./rank3.png": "./src/assets/imgs/school/monthRecord/rank3.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/imgs/school/monthRecord sync recursive ^\\.\\/rank.*\\.png$";